import React from "react";
import { useRef } from "react";
import { Form, Divider, Input, DatePicker, Button } from 'antd';
import { MinusCircleOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
const { TextArea } = Input;


const PurchaseRequisition = () => {
    const purchaseRequisitionAddButtonRef = useRef(null);
    return (
        <div className="col-lg-12 col-md-12">
            <Form.List name="purchase_requisition">
                {(purchaseRequisitions, { add, remove }) => {
                    if (purchaseRequisitions.length == 0 && purchaseRequisitionAddButtonRef.current) {
                        purchaseRequisitionAddButtonRef.current.click();
                    }
                    return (
                        <div>
                            {purchaseRequisitions.map((field, index) =>
                                <div key={field.key} className="row">

                                    {purchaseRequisitions.length > 1 &&
                                        (<div className="col-lg-12 col-md-12" style={{ display: 'flex', justifyContent: "space-between", alignItems: "center", background: "#d3d3d34a", marginBottom: "15px" }}>
                                            <div>
                                                #{index + 1}
                                            </div>
                                            {purchaseRequisitions.length > 1 &&
                                                <Button
                                                    type="link"
                                                    className="dynamic-delete-button"
                                                    onClick={() => { remove(field.name) }}
                                                    icon={<DeleteOutlined style={{ color: "red" }} />}
                                                >
                                                </Button>
                                            }
                                        </div>)}
                                    <div className="col-lg-6 col-md-12">
                                        <Form.Item
                                            name={[index, "pr_no"]}
                                            label="PR Number"
                                            rules={[{ required: true, message: "Please enter PR Number" }]}>
                                            <Input placeholder="Enter PR Number" />
                                        </Form.Item>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <Form.Item
                                            name={[index, "line_items"]}
                                            label="Line Items"
                                            rules={[{ required: true, message: "Please enter PR Number" }]}>
                                            <Input placeholder="Enter PR Number" />
                                        </Form.Item>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <Form.Item
                                            name={[index, "wbs_no"]}
                                            label="WBS Number"
                                            rules={[{ required: true, message: "Please enter PR Number" }]}>
                                            <Input placeholder="Enter PR Number" />
                                        </Form.Item>
                                    </div>
                                    <div className="col-lg-6 col-md-12">
                                        <Form.Item
                                            name={[index, "rfq_no"]}
                                            label="RFQ Number"
                                            rules={[{ required: true, message: "Please enter PR Number" }]}>
                                            <Input placeholder="Enter PR Number" />
                                        </Form.Item>
                                    </div>
                                </div>
                            )}
                            <Divider />
                            <div className="row">
                                <div className="col-lg-12 col-md-12" style={{textAlign: "right"}}>
                                    <Form.Item>
                                        <Button
                                            ref={purchaseRequisitionAddButtonRef}
                                            type="primary"
                                            onClick={() => add()}
                                        >
                                            <PlusOutlined />
                                            {purchaseRequisitions.length > 0 ? "Add more" : "Add"}
                                        </Button>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    );
                }}
            </Form.List>
        </div>
    )
}

export default PurchaseRequisition;